<template>
    <b-container fluid>
        <b-row class="justify-content-center">
            <b-col cols="12" md="7" lg="4">
                <div class="SocietyMatchesHandlePayment">
                    <div class="SocietyMatchesHandlePayment-logo">
                        <div class="SocietyMatchesHandlePayment-logo-bg">
                        </div>
                        <img :src="srcLogo" alt="logo"/>
                    </div>
                    <div class="SocietyMatchesHandlePayment-form my-3 px-3">
                        <h1 class="text-primary mb-3 text-uppercase text-center">
                            società sportive
                        </h1>
                        <div v-if="loading">
                            <h2 class="my-4 text-center text-uppercase text-primary">
                                STIAMO ELABORANDO<br/>
                                IL TUO PAGAMENTO
                            </h2>
                            <p class="mt-3 text-center">
                                Attendi qualche secondo
                            </p>
                        </div>
                        <div v-if="!loading">
                            <div v-if="queryParams.esito === 'OK'">
                                <h2 class="my-4 text-center text-uppercase text-primary">
                                    IL TUO PAGAMENTO <br>è andato a buon fine
                                </h2>
                                <p class="mt-3 text-center">
                                    Tra qualche secondo,<br> verrai reindirizzato nuovamente nel portale
                                </p>
                            </div>
                            <div v-else>
                                <h2 class="my-4 text-center text-uppercase text-danger">
                                    IL TUO PAGAMENTO <br>non è andato a buon fine
                                </h2>
                                <p class="mt-3 text-center">
                                    Tra qualche secondo,<br>
                                    verrai reindirizzato nuovamente nel portale<br>
                                    e potrai riprovare ad effettuare il pagamento,<br>
                                    rientrando nel dettaglio della richiesta
                                </p>
                            </div>
                            <p class="mt-3 text-center">
                                Per qualsiasi informazione, scrivi pure a<br>
                                <a class="text-primary" href="mailto:bigliettiscuolecalcio@inter.it">
                                    bigliettiscuolecalcio@inter.it
                                </a>
                            </p>
                            <div>
                                <inter-button
                                        class="mx-auto"
                                        label="prosegui"
                                        @onClick="showRequest">
                                </inter-button>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {mapActions} from 'vuex';
    import InterButton from "../../../components/form/inter-button/InterButton";

    export default {
        name: "SocietyMatchesHandlePaymentView.vue",
        components: {InterButton},
        data() {
            return {
                srcLogo: require('@/assets/media/logo.svg'),
                success: false,
                queryParams: this.$route.query || {},
                loading: true,
                request: null,
                response: null
            }
        },
        async mounted() {
            try {
                this.loading = true;
                this.queryParams = {
                    ... this.queryParams,
                    ... { from_front : true }
                }
                const response = await this.societyMatchesHandlePaymentResponse(this.queryParams);

                this.success = response.success;
                this.request = response.request;
                this.response = response;

                // eslint-disable-next-line no-console
                console.log('Redirecting in 7 seconds')
                setTimeout(async () => {
                    // eslint-disable-next-line no-console
                    console.log('Redirecting')
                    await this.showRequest();
                }, 7000);

            } catch (e) {
                await this.$bvToast.toast('Ci sono stati problemi nella elaborazione del pagamento', {
                    title: 'Alert',
                    variant: 'warning'
                });
            } finally {
                this.loading = false;
            }
        },
        methods: {
            ...mapActions({
                societyMatchesHandlePaymentResponse : 'societyMatchesHandlePaymentResponse',
                societyMatchesShowRequest : 'societyMatchesShowRequest'
            }),

            async showRequest() {
                try {
                    //const data = await this.societyMatchesShowRequest(this.request);
                    await this.$router.push({name: 'society.dash'})
                    // await this.$router.push({name: 'society.matches.request', params: {id: this.response.request_id}})
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log('Error', e)
                    await this.$bvToast.toast('Errore nella richiesta', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
